export default () => ({
  root: {
    width: '100%',
    padding: 20,
  },
  iconButton: {
    marginBottom: '2px',
    color: 'black',
    backgroundColor: 'transparent !important',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  block: {
    flexDirection: 'column',
  },
  title: {
    margin: 5,
  },
  filterBox: {
    padding: 10,
  },
  button: {
    marginBottom: '2px',
    color: 'black',
    backgroundColor: 'transparent !important',
  },
  dateField: {
    width: 180,
    marginTop: 10,
  },
  selectField: {
    width: 180,
  },
  actionFields: {
    marginTop: 15,
  },
  fieldContainer: {
    marginTop: '-40px',
    marginLeft: '-30px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '100%',
    flex: 1,
    marginLeft: 30,
    marginRight: 30,
  },
  row: {
    display: 'flex',
    marginTop: 20,
  },
  checkbox: {
    marginLeft: 0,
  },
});
